import {Component} from 'react';
import PropTypes from 'prop-types';

import './social-button.less';
import {Enums} from '_app/utils';
import {appConfigService} from '_app/services';

export default class SocialSection extends Component {
	static propTypes = {
		type: PropTypes.number.isRequired,
		shareText: PropTypes.string,
		onSocialShare: PropTypes.func.isRequired
	}

	state = {
		token: this.generateToken()
	};

	componentDidMount() {
		var shareTypes = Enums.getType('shareTypes');
		var self = this;

		switch (this.props.type) {
			case shareTypes.TWITTER:
				break;
			case shareTypes.LINKEDIN:
				if (typeof window.IN !== 'undefined') {
					window.IN.Event.on(window.IN, 'frameworkLoaded', function() {
						window.IN.parse();
						$('.social-section-buttons').on('click', 'span.IN-widget', self.addMediaShare);
					});
				}
				break;
			case shareTypes.FACEBOOK:
				if (typeof window.FB !== 'undefined') {
					window.FB.init({
						xfbml: true,
						version: 'v2.9'
					});
				}
				break;
			default:
				break;
		}
	}

	saveSocialDivRef = ref => {
		this.socDiv = ref;
	}

	socialClick = ev => {
		const {shareUrl} = this.socDiv.children[0].dataset;

		this.addMediaShare(ev).then(() => {
			if (this.socDiv.children[0].className === 'twttr-share-control') {
				window.open('https://twitter.com/intent/tweet?' +
						'text=' + encodeURIComponent(this.props.shareText) +
						'&url=' + encodeURIComponent(shareUrl),
				'_blank', 'location=no,height=449,width=533,scrollbars=no,status=yno');
			} else if (this.socDiv.children[0].className === 'fb-share-control') {
				window.open('https://www.facebook.com/sharer/sharer.php?' +
					'kid_directed_site=0&sdk=joey&u=' + encodeURIComponent(shareUrl) +
						'&display=popup&ref=plugin&src=share_button',
				'_blank', 'location=no,height=570,width=520,scrollbars=no,status=yno');
			}
		});
	}

	addMediaShare = () => {
		const {token} = this.socDiv.dataset;

		return this.props.onSocialShare(token, this.props.type).always(() => this.setState({
			token: this.generateToken()
		}));
	}

	generateToken() {
		var token = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : (r & 0x3 | 0x8);

			return v.toString(16);
		});

		return token;
	}

	render() {
		var shareTypes = Enums.getType('shareTypes');
		var {token} = this.state;
		var shareUrl = appConfigService.get('serverPath') + 'MediaServe/MediaLink?token=' + token;
		var btnNode;

		switch (this.props.type) {
			case shareTypes.TWITTER:
				if (typeof twttr !== 'undefined') {
					btnNode = (
						<div data-share-url={shareUrl} className="twttr-share-control">
							<button className="social-share-button twttr-share-button" onClick={this.socialClick}>
								<i className="social-share-logo fa fa-x-twitter fa-lg tw-icon width-16" />
								<div className="social-share-text">Share</div>
							</button>
						</div>
					);
				}
				break;
			case shareTypes.LINKEDIN:
				if (typeof IN !== 'undefined') {
					btnNode = (<script type="IN/Share" data-url={shareUrl} />);
				}
				break;
			case shareTypes.FACEBOOK:
				if (typeof window.FB !== 'undefined') {
					btnNode = (
						<div data-share-url={shareUrl} className="fb-share-control">
							<button className="social-share-button fb-share-button" onClick={this.socialClick}>
								<svg className="social-share-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16">
									<path fill="#ffffff" fillRule="evenodd"
										d="M8 14H3.667C2.733 13.9 2 13.167 2 12.233V3.667A1.65 1.65 0 0 1
											3.667 2h8.666A1.65 1.65 0 0 1 14 3.667v8.566c0 .934-.733
											1.667-1.667
											1.767H10v-3.967h1.3l.7-2.066h-2V6.933c0-.466.167-.9.867-.9H12v-1.8c.033
											0-.933-.266-1.533-.266-1.267 0-2.434.7-2.467
											2.133v1.867H6v2.066h2V14z"
									/>
								</svg>
								<div className="social-share-text ps-5">Share</div>
							</button>
						</div>
					);
				}
				break;
			case shareTypes.EMAIL:
				btnNode = (
					<div>
						<button className="social-share-button email-share-button" onClick={this.props.onSocialShare}>
							<i className="social-share-logo fa fa-envelope-o" />
							<div className="social-share-text ps-5">Email</div>
						</button>
					</div>
				);
				break;
			default:
				btnNode = null;
		}
		if (btnNode) {
			return (
				<div ref={this.saveSocialDivRef} data-token={token} style={{
					marginRight:'10px'
				}}
				>
					{btnNode}
				</div>
			);
		} else {
			return (
				<div style={{
					display:'none'
				}}
				/>
			);
		}
	}
}